export default __webpack_public_path__ + "static/media/teodor-drobota-4k.7173bef8.jpg";